import { polygon, intersect,lineString, lineOffset, lineToPolygon, centerOfMass } from '@turf/turf'

var poly1 =polygon([[
    [-122.801742, 45.48565],
    [-122.801742, 45.60491],
    [-122.584762, 45.60491],
    [-122.584762, 45.48565],
    [-122.801742, 45.48565]
  ]]);
  
  var poly2 =polygon([[
    [-122.520217, 45.535693],
    [-122.64038, 45.553967],
    [-122.720031, 45.526554],
    [-122.669906, 45.507309],
    [-122.723464, 45.446643],
    [-122.532577, 45.408574],
    [-122.487258, 45.477466],
    [-122.520217, 45.535693]
  ]]);

  
 export const GiaoThoaPolygon = (polyg1,polyg2) =>{

    var intersection = intersect(poly1, poly2);
    // console.log(intersection)
    return intersection
}

/**
 * Adds two numbers.
 * @param {point} Điểm gốc
 * @param {distance} khoảng cách dịch chuyển mét
 * @param {heading} 
 * @return {Array} The result GEOJSON 
 */
export const DiChuyenDiem = (point,distance,heading) =>{
  
}

/**
 * Adds two numbers.
 * @param {lines} danh mục đường line [[lat,lng],...] 
 * @param {distance} khoảng cách dịch chuyển mét có thể âm
 * @return {Array} The result GEOJSON 
 */
export const DichChuyenDuong = (lines,distance) =>{

  var line = lineString(lines);
  var offsetLine = lineOffset(line, distance, {units: 'meters'});
  return offsetLine.geometry.coordinates
}

/**
 * Adds two numbers.
 * @param {lines} danh mục đường line [[lat,lng],...] 
 * @return {Array} The result GEOJSON 
 */
export const LineToPolyGon = (lines) =>{

  var line = lineString(lines);
  var offsetLine = lineToPolygon(line) 
  return offsetLine
}

/**
 * Adds two numbers.
 * @param {polygon} polygon [[lat,lng],...] 
 * @return {Array} The result GEOJSON 
 */
 export const FindCenterPointPolygon = (polygons) =>{
  var polygn = polygon(polygons);
  var centerPoint = centerOfMass(polygn) 
  return centerPoint
}

/**
 * Adds two numbers.
 * @param {polyArr} Array Point of Polygons
 * @param {type} type: 1 {lat: lat(), lng: lng()}  | type: 2 {lat: xxx, lng: xxx}
 * @return {Array} The result GEOJSON 
 */
 export const ConvertArrObjectToGEO = (polyArr, type) =>{
    //type: 1 {lat: lat(), lng: lng()} 
    //type: 2 {lat: xxx, lng: xxx}
    let arrayReturn = []
    if(type === 1){
        polyArr.forEach(e=>{
            // console.log(e.lat())
            arrayReturn.push([e.lat() , e.lng()])
        })
        // console.log(polyArr)
    }
    else{
        polyArr.forEach(e=>{
            arrayReturn.push([e.lat , e.lng])
        }) 
    }
  return arrayReturn
}
  //=polygons
  
  //=intersection